module.exports = __webpack_public_path__ + "img/argentina.ffe8a18b.png";